<template lang="pug">
.diagnosticsItemLandingComponent(v-if="item")
  router-link.backLink(:to="{ name: 'DiagnosticsList' }")
    .icon
      ui-svg-icon(name="arrow-back")
    .text Витрина диагностик
  .header
    diagnostics-item-landing-header(
      :item-controller="itemController"
      :state-controller="stateController"
    )
  template(v-if="item.descriptionFull")
    .title Описание диагностики профессиональных компетенций
    .section
      diagnostics-item-landing-description(
        :text="item.descriptionFull"
        :competence="item.competenceName"
        :attempts="item.attempts"
        :questions-count="item.questionsCount"
        :duration="item.duration"
        :button-color="item.profile?.code"
      )
  template(v-if="item.aquirements.length")
    .title После прохождения вы получите
    .section
      diagnostics-item-landing-aquirements(:items="item.aquirements")
  template(v-if="item.themes.length")
    .title Исследуемые тематики в диагностике профессиональных компетенций
    .section
      diagnostics-item-landing-themes(:items="item.themes")
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import DiagnosticsItemLandingHeader from './DiagnosticsItemLandingHeader.vue'
import DiagnosticsItemLandingDescription from './DiagnosticsItemLandingDescription.vue'
import DiagnosticsItemLandingAquirements from './DiagnosticsItemLandingAquirements.vue'
import DiagnosticsItemLandingThemes from './DiagnosticsItemLandingThemes.vue'
import type DiagnosticsItemController from '@diagnostics/controllers/DiagnosticsItemController'
import type DiagnosticsItemStateController from '@diagnostics/controllers/DiagnosticsItemStateController'

// Props
interface Props {
  itemController: ReturnType<typeof DiagnosticsItemController>
  stateController: ReturnType<typeof DiagnosticsItemStateController>
}
const props = defineProps<Props>()

// Course data
const item = computed(() => props.itemController.data.value)
</script>

<style lang="sass" scoped>
.diagnosticsItemLandingComponent
  // ВЫДЕЛИТЬ В UI КОМПОНЕНТ UiLink
  > .backLink
    @include font(t14)
    color: $colorGray
    margin-bottom: 5*$u
    display: flex
    align-items: center
    cursor: pointer

    > .icon
      width: 4*$u
      height: 4*$u
      flex: 0 0 4*$u
      margin-right: 2*$u

    &:hover
      text-decoration: underline

  > .header
    margin-bottom: 20*$u

  > .title
    @include font(h2)
    color: $colorPrimary
    margin-bottom: 6*$u

  > .section
    margin-bottom: 20*$u

  @media screen and (max-width: $screenSizeS)
    > .header
      margin-bottom: 12*$u

    > .title
      margin-bottom: 4*$u

    > .section
      margin-bottom: 15*$u
</style>
